import { connect } from "react-redux";
import {
  displayReservationMessage,
  getBagItems,
  getSellerChanged
} from "../../../state/modules/bag";
import ReservationMessage from "./ReservationMessage";

const mapStateToProps = state => ({
  displayReservationMessage: displayReservationMessage(state),
  sellerChanged: getSellerChanged(state),
  items: getBagItems(state)
});

export default connect(mapStateToProps)(ReservationMessage);
